<template>
  <div id="app">
    <Header v-if="!$route.meta.isHidden"></Header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view class="main-view" v-if="!$route.meta.keepAlive" />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
import common from "@/mixins/common.js";
export default {
  name: "App",
  mixins: [common],

  watch: {
    $route(to) {
      let list = to.matched.map(item => {
        if (item.path == "") {
          item.path = "/";
        }
        return {
          title: item.meta.title,
          path: item.path
        };
      });
      this.$store.commit("SetRouteList", list);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue